<template>
  <b-modal
    id="modal-member-contract"
    cancel-variant="outline-secondary"
    centered
    hide-footer
    size="xl"
    :ok-disabled="false"
    headerClass="px-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
  >
    <modal-pdf title="會員合約" :pdf-url="signPDFUrl" />
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div class="d-flex flex-wrap flex-lg-nowrap align-items-center">
        <h3 class="font-weight-bolder text-nowrap mb-0">
          <feather-icon size="18" icon="UserIcon" />
          會員合約
        </h3>
        <div class="form-col-select ml-2">
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block"
          />
          <feather-icon size="18" icon="ChevronDownIcon" />
        </div>
        <div class="search-primary ml-2">
          <feather-icon size="16" icon="SearchIcon" />
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="搜尋客戶"
          />
        </div>
      </div>
      <b-table
        ref="refMemberContractTable"
        class="position-relative mt-2"
        :items="fetchMemberContracts"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="未找到匹配的記錄"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(supplier_id)="data">
            {{ data.item.supplier && data.item.supplier.company_name_cn }}
        </template>


        <template #cell(signed_contract_path)="data">
            <b-button variant="primary" @click="exportContract(data.item.id)">
                <feather-icon icon="FileIcon" />
            </b-button>
        </template>
<!-- 
        <template #cell(signature_path)="data">
            <div v-if="data.item.signature_path && data.item.signature_path.indexOf('.pdf') > -1">
               <embed :src="imageBaseUrl + data.item.signature_path" type="application/pdf" width="100%" height="100%" />
            </div>
            <div v-else>
                <img :src="imageBaseUrl + data.item.signature_path" alt="簽署" style="width: 100px;">
            </div>
        </template>

        <template #cell(signed_contract_path)="data">
            <div v-if="data.item.signed_contract_path && data.item.signed_contract_path.indexOf('.pdf') > -1">
               <embed :src="imageBaseUrl + data.item.signed_contract_path" type="application/pdf" width="100%" height="100%" />
            </div>
            <div v-else>
                <img :src="imageBaseUrl + data.item.signed_contract_path" alt="合約" style="width: 100px;">
            </div>
        </template> -->

        <template #cell(member_contract_status_id)="data">
            {{ data.item.member_contract_status && data.item.member_contract_status.name }}
        </template>

        <template #cell(approve_id)="data">
            {{ data.item.approve && data.item.approve.name }}
        </template>


        <!-- Column: create time -->
        <template #cell(created_at)="data">
          <div class="d-flex" style="width: 160px">
            {{
              data.item.created_at && getCorrectDateTime(data.item.created_at)
            }}
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
              {{ dataMeta.to }}個記錄</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import { ref, watch, computed } from "@vue/composition-api";

import vSelect from "vue-select";
import store from "@/store";
import ModalPdf from '@/layouts/components/file/ModalPdf.vue';
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BTable,
    BPagination,
    BFormCheckbox,
    BOverlay,
} from "bootstrap-vue";

export default {
  name: "UpgradeContract",
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BTable,
    BPagination,
    BFormCheckbox,
    BOverlay,
    vSelect,
    ModalPdf,
  },
//   props: {
//     contracts: {
//       type: Array,
//       required: true,
//     },
//   },
  data() {
    return {
      loading: false,
      signPDFUrl: null,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-member-contract");
    },
    exportContract(id) {
      this.loading = true;
      this.$store.dispatch('app/exportContract', { id: id })
        .then((res) => {
          const filepdf = new Blob([res.data], {
            type: "application/pdf",
          });
          this.signPDFUrl = URL.createObjectURL(filepdf);
          this.$bvModal.show('modal-pdf');
          
          // const link = document.createElement('a');
          // link.href = URL.createObjectURL(filepdf);
          // link.download = `contract_${id}.pdf`;
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // URL.revokeObjectURL(link.href);
          
        })
        .catch((error) => {
          console.error('PDF export error:', error);
          
          let errorMessage = 'PDF檔案已過期';
          
          if (error.response) {
            // 服務器返回了錯誤狀態碼
            if (error.response.status === 404) {
              errorMessage = '找不到該合約文件';
            } else if (error.response.status === 403) {
              errorMessage = '您沒有權限存取此文件';
            } else if (error.response.status >= 500) {
              errorMessage = '伺服器錯誤，請稍後再試';
            } else if (error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          } else if (error.request) {
            // 請求已發出但沒有收到回應
            errorMessage = '網路連接失敗，請檢查網路連接';
          } else {
            // 其他錯誤
            errorMessage = error.message || '未知錯誤';
          }
          
          this.$swal({
            text: errorMessage,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        })
        .finally(() => {
          // 確保在任何情況下都會隱藏loading
          this.loading = false;
        });
    },
  },
  setup() {
    const refMemberContractTable = ref(null);
    const imageBaseUrl = process.env.VUE_APP_IMAGE_URL;

    // Table Handlers
    const tableColumns = [
      { key: "id", label: "ID", sortable: true },
      {
        key: "supplier_id",
        label: "供應商",
        sortable: true,
      },
    //   { key: "signature_path", label: "簽署", sortable: true },
      { key: "signed_contract_path", label: "合約", sortable: true },
      { key: "signed_date", label: "簽署日期" },
      { key: "member_contract_status_id", label: "合約狀態" },
    //   { key: "approve_id", label: "審核", sortable: true },
    //   { key: "approve_note", label: "審核備註", sortable: true },
      { key: "reject_reason", label: "備註" },
      { key: "created_at", label: "創建時間", sortable: true },
    //   { key: "actions", label: "列印" },
    ];
    const perPage = ref(10);
    const totalRows = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);

    const dataMeta = computed(() => {
      const localItemsCount = refMemberContractTable.value
        ? refMemberContractTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalRows.value,
      };
    });
    const toast = useToast();

    const refetchData = () => {
        refMemberContractTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });

    const fetchMemberContracts = (ctx, callback) => {
      store
        .dispatch("app/fetchMemberContracts", {
          q: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
        })
        .then((response) => {
          const { member_contracts, total } = response.data;
          callback(member_contracts);
          totalRows.value = total;
        })
        .catch((err) => {
          console.log(err);
          toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching client list",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      imageBaseUrl,
      tableColumns,
      dataMeta,
      perPage,
      totalRows,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMemberContractTable,
      fetchMemberContracts,
    };
  },
};
</script>
<style>
</style>